import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { StorageService } from './storage.service';

declare var _: any;
declare var SockJS: any;
declare var Stomp: any;

@Injectable({
  providedIn: 'root'
})
export class WebSocketsService {
  urlConstants: any = {
    WEB_SOCKET_CONNECTION_URL: 'register',
    ECHO_URL: '/topic/echo',
    USER_NOTIFICATIONS: '/queue/{userId}/notifications',
    MESSAGE_NOTIFICATIONS: '/queue/{userId}/chatMessage',
    WORKFLOW_UPDATE: '/queue/{userId}/workflowUpdate',
    SEND_URL: '/send/url',
    WEB_SOCKET_CONNECTION_URL_FOR_CHIME: 'register/chime',
    CHIME_NOTIFICATIONS: '/chime/{participantId}/notifications'
  };

  chimeParticipantId: any = null;
  isChimeListenerListening = false;

  private listener = new Subject<any>();
  private listenerForChime = new Subject<any>();
  private messageListener = new Subject<any>();
  private workflowUpdateListener = new Subject<any>();
  // Separate from workflowUpdateListener, which pages complete and recreate when they are destroyed.
  private bulkUploadListener = new Subject<any>();

  private chimeConnectedSource = new Subject<void>();
  chimeConnected: Observable<void> = this.chimeConnectedSource.asObservable();

  socket: any = {
    client: null,
    stomp: null
  };

  socketForChime: any = {
    client: null,
    stomp: null
  };

  messageIds: any[] = [];

  private reconnect: () => void;
  private reconnectForChime: () => void;
  private initialize: () => void;
  private initializeForChime: () => void;
  private getMessage: (data: any) => any;
  private startListener: () => void;
  private startListenerForChime: () => void;

  constructor(
    @Inject(StorageService) private StorageService: StorageService
  ) {
    this.reconnect = () => {
      setTimeout(() => {
        this.initialize();
      }, 6000);
    };

    this.reconnectForChime = () => {
      setTimeout(() => {
        this.initializeForChime();
      }, 6000);
    };

    this.initialize = () => {
      if ((_.isNull(this.socket.stomp) || !this.socket.stomp.connected) && this.StorageService.get('userDetails')) {
        this.socket.client = new SockJS(this.StorageService.get('baseurl') + '/' + this.urlConstants.WEB_SOCKET_CONNECTION_URL);
        this.socket.stomp = Stomp.over(this.socket.client);
        this.socket.stomp.connect({}, this.startListener, this.reconnect);
      }
    };

    this.initializeForChime = () => {
      if (_.isNull(this.socketForChime.stomp) || !this.socketForChime.stomp.connected) {
        this.socketForChime.client = new SockJS(this.StorageService.get('baseurl') + '/' + this.urlConstants.WEB_SOCKET_CONNECTION_URL_FOR_CHIME);
        this.socketForChime.stomp = Stomp.over(this.socketForChime.client);
        this.socketForChime.stomp.connect({}, this.startListenerForChime, this.reconnectForChime);
      }
    };

    this.getMessage = (data: any) => {
      let message = JSON.parse(data.body);
      return message;
    };

    this.startListener = () => {
      const userDetails = this.StorageService.get('userDetails');
      if (!userDetails) {
        return;
      }

      this.socket.stomp.subscribe(this.urlConstants.USER_NOTIFICATIONS.replace('{userId}', userDetails.id), (data: any) => {
        this.listener.next(this.getMessage(data));
      });

      this.socket.stomp.subscribe(this.urlConstants.MESSAGE_NOTIFICATIONS.replace('{userId}', userDetails.id), (data: any) => {
        this.messageListener.next(this.getMessage(data));
      });

      this.socket.stomp.subscribe(this.urlConstants.WORKFLOW_UPDATE.replace('{userId}', userDetails.id), (data: any) => {
        const message = this.getMessage(data);
        if (message.bulkUpload) {
          this.bulkUploadListener.next(message.bulkUpload);
          return;
        }
        console.log('Workflow Update alert:');
        console.log(message);
        this.workflowUpdateListener.next(message);
      });
    };

    this.startListenerForChime = () => {
      this.chimeConnectedSource.next();
      this.socketForChime.stomp.subscribe(this.urlConstants.CHIME_NOTIFICATIONS.replace('{participantId}', this.chimeParticipantId), (data: any) => {
        this.listenerForChime.next(this.getMessage(data));
      });
    };
  }

  connect() {
    this.initialize();
  }

  connectForChime(chimeParticipantId: any) {
    this.chimeParticipantId = chimeParticipantId;
    this.initializeForChime();
  }

  receive() {
    return this.listener.asObservable();
  }

  receiveMessage() {
    return this.messageListener.asObservable();
  }

  receiveBulkUpload() {
    return this.bulkUploadListener.asObservable();
  }

  receiveWorkflowUpdate() {
    return this.workflowUpdateListener.asObservable();
  }

  receiveChimeNotification() {
    this.isChimeListenerListening = true;
    return this.listenerForChime.asObservable();
  }

  send(message: any) {
    let id = Math.floor(Math.random() * 1000000);
    this.socket.stomp.send(this.urlConstants.SEND_URL, {
      priority: 9
    }, JSON.stringify({
      message: message,
      id: id
    }));
    this.messageIds.push(id);
  }

  disconnect() {
    if (!_.isNull(this.socket.stomp) && this.socket.stomp.connected) {
      this.socket.stomp.disconnect(() => {
        console.log('Web socket disconnected.');
      });
    }
  }

  disconnectForChime() {
    if (!_.isNull(this.socketForChime.stomp) && this.socketForChime.stomp.connected) {
      this.socketForChime.stomp.disconnect(() => {
        console.log('Web socket for chime disconnected.');
      });
    }
  }

  setWorkflowUpdateListener() {
    this.workflowUpdateListener = new Subject<any>();
  }

  resetWorkflowUpdateListener() {
    this.workflowUpdateListener.complete();
    this.setWorkflowUpdateListener();
  }
}
